<template>
  <a class="d-flex justify-content-center mb-2 mb-lg-4" href="/">
    <img src="/images/logo.png" width="220" alt="Mobile Tool Network" />
  </a>
</template>
